module.exports = __webpack_public_path__ + "img/walk.bbb74aa4.svg";